module.exports = __webpack_public_path__ + "static/media/request-data.3e8090cb.svg";